import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _TvdLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M19.002 15.818h-2.413V8h2.52q1.137 0 1.946.47.81.465 1.241 1.34.431.87.431 2.084 0 1.221-.435 2.103a3.1 3.1 0 0 1-1.267 1.352q-.833.47-2.023.47m-1.466-.84h1.404q.97 0 1.608-.374.637-.374.95-1.065.313-.69.313-1.645 0-.947-.31-1.63a2.28 2.28 0 0 0-.923-1.054q-.615-.37-1.53-.37h-1.512zM9.645 8l2.32 6.581h.092L14.38 8h.992l-2.87 7.818h-.978L8.653 8zM2 8.84V8h5.864v.84H5.405v6.978h-.947V8.84z" })));
}
const TvdLightCustom = forwardRef(_TvdLightCustom);
export { TvdLightCustom };
